import { RoundMatch } from "@/models";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  getRoundMatches(roundId: number) {
    return axios.get().get<ApiResponse<RoundMatch[]>>(`/rounds/${roundId}/matches`);
  },
  downloadRefereePdf: async (roundId: number) => {
    const response: any = await axios.get().get<any>(`/rounds/${roundId}/referee_pdf`, {
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    const contentDisposition = response.headers["content-disposition"];
    const filename = decodeURIComponent(escape(contentDisposition.match(/filename="(.+)"/)[1]));
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  }
};
